import { enUS, ru } from 'date-fns/locale';
import type { Locale } from 'date-fns';
import { useTranslation } from 'react-i18next';

/** date-fns Locale for a given i18n language code ('ru', 'ru-RU', 'en', ...). */
export function dateFnsLocale(language: string): Locale {
  return language.startsWith('ru') ? ru : enUS;
}

/** Reactive date-fns locale — re-renders the component on language change. */
export function useDateLocale(): Locale {
  const { i18n } = useTranslation();
  return dateFnsLocale(i18n.language);
}

/** BCP-47 tag for toLocaleDateString calls. */
export function dateLocaleTag(language: string): string {
  return language.startsWith('ru') ? 'ru-RU' : 'en-GB';
}
